import React from 'react';
import DateInput2, { WrapperProps } from '.';
import useClassrooms from '@teetsh/app/src/containers/App/context/ClassroomsContext/useClassrooms';
import { getMutualWorkingDays } from '@teetsh/app/src/containers/utils';

export default function SchoolDateInput(props: WrapperProps) {
  const classrooms = useClassrooms();
  const workingDays = getMutualWorkingDays(classrooms).map(w => (w + 1) % 7);
  return (
    <DateInput2
      {...props}
      disabledDays={[0, 1, 2, 3, 4, 5, 6].filter(d => !workingDays.includes(d))}
    />
  );
}
